module.exports = __webpack_public_path__ + "img/CS-Profi-User.30156229.jpg";